import { PROVINCE_ABBREVIATION_MAP } from '@constants/leadCaptureConstants';

/**
 * Inverse of `PROVINCE_ABBREVIATION_MAP`, derived from it rather than declared
 * a second time — a hand-synced copy would drift the first time a territory is
 * added to only one of them.
 */
const SLUG_TO_ABBREVIATION: Record<string, string> = Object.fromEntries(
  Object.entries(PROVINCE_ABBREVIATION_MAP).map(([abbreviation, slug]) => [slug, abbreviation])
);

/**
 * The province select stores a slug (`british_columbia`); the qualification
 * contract takes an abbreviation (`BC`). Unknown slugs yield an empty string so
 * validation, not this function, is what reports a missing province.
 */
export const provinceSlugToAbbreviation = (slug: string): string => SLUG_TO_ABBREVIATION[slug] ?? '';
